import { Component, input, output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { GamesService } from '../../../services/games/games.service';
import { Game } from '../../../views/home/library/library';

@Component({
  selector: 'app-game-details-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './game-details-modal.html',
  styleUrl: './game-details-modal.scss'
})
export class GameDetailsModal {
  private gamesService = inject(GamesService);

  public game = input<Game | null>(null);
  public closed = output<void>();
  public gameUpdated = output<{ id: string; customInstallPath?: string; customExecutable?: string; installed: boolean }>();
  public launched = output<Game>();

  public close() {
    this.closed.emit();
  }

  public async browseGamePath(event?: Event) {
    if (event) event.stopPropagation();
    const currentGame = this.game();
    if (!currentGame) return;

    const res = await this.gamesService.browseGamePath(currentGame.id);
    if (res.success && (res.path || res.executable)) {
      const isInstalled = res.installed !== undefined ? res.installed : true;
      this.gameUpdated.emit({
        id: currentGame.id,
        customInstallPath: res.path || currentGame.customInstallPath,
        customExecutable: res.executable || currentGame.customExecutable,
        installed: isInstalled
      });
    }
  }

  public async updateGamePath(newPath: string) {
    const currentGame = this.game();
    if (!currentGame) return;
    const trimmed = newPath.trim();
    if (trimmed === (currentGame.customInstallPath || '')) return;

    const res = await this.gamesService.setGamePath(currentGame.id, trimmed);
    const isInstalled = res.installed !== undefined ? res.installed : currentGame.installed;

    this.gameUpdated.emit({
      id: currentGame.id,
      customInstallPath: trimmed,
      customExecutable: currentGame.customExecutable,
      installed: isInstalled
    });
  }

  public async updateGameExecutable(newExecutable: string) {
    const currentGame = this.game();
    if (!currentGame) return;
    const trimmed = newExecutable.trim();
    if (trimmed === (currentGame.customExecutable || '')) return;

    const res = await this.gamesService.setGameExecutable(currentGame.id, trimmed);
    const isInstalled = res.installed !== undefined ? res.installed : currentGame.installed;

    this.gameUpdated.emit({
      id: currentGame.id,
      customInstallPath: currentGame.customInstallPath,
      customExecutable: trimmed,
      installed: isInstalled
    });
  }

  public async playLaunchGame(event?: Event) {
    if (event) event.stopPropagation();
    const currentGame = this.game();
    if (!currentGame) return;

    if (!currentGame.installed) {
      await this.browseGamePath();
      return;
    }

    const launched = await this.gamesService.launchGame(currentGame.id);
    if (launched) {
      this.launched.emit(currentGame);
    } else {
      console.warn('Game launch was not successful or container API not present.');
    }
  }
}
